<script>
    import { fade } from 'svelte/transition';
    import Hero from '../components/FVHero.svelte'
    import Centering from '../layouts/Centering.svelte'
    import Tab from '../components/Tab.svelte';
    const src = {
        pc:"img/products/bg.png",
        mb:"img/products/bg_m.png"
    }
</script>
<svelte:head>
	<title>商品について | 株式会社有倉商店</title>
</svelte:head>
<div transition:fade>
    <Hero images={src} />
    <Centering>
        <div class="top-layout">
            <h2>PRODUCTS</h2>
            <p>商品について</p>
        </div>
    </Centering>
    <div class="desc">
        <div class="txt">
            有倉では、下処理（カット）野菜のご注文を承っています。
            下処理の種類は「あとは切るだけ」の皮むき状態のものから、
            乱切り・いちょう切り・短冊切りなど最終加工のものまで
            ニーズに合わせた商品をお届けいたします。
            規格（サイズ・重量）につきましてはフレキシブルにご対応
            いたしますのでご相談ください。
            「人件費削減」「ゴミ削減」「下処理時間短縮」「人手不足
            解消」など貴社が抱えている多くの問題を解決できます。
        </div>
    </div>
    <Centering>
        <div class="hdr-layouts">
            <span class="vr"></span><h3>有倉で扱っている野菜とその加工方法</h3>
        </div>
    </Centering>
    <Centering>
        <Tab/>
    </Centering>
</div>


<style>
    .top-layout{
        display: flex;
    }
    h2{
        font-family: "Noto Sans JP",sans-serif;
        font-weight: normal;
        font-size: 60px;
        line-height: 41px;
        text-align: left;
        color: #000;
    }
    h2+p{
        font-family: 'Noto Sans JP';
        font-style: normal;
        font-weight: 500;
        font-size: 24px;
        line-height: 24px;
        color: #000000;
        margin-top: 50px;
        margin-left: 24px;
    }
    .desc{
        background-image: url(/img/products/pic_intro_products.png);
        width: 100%;
        height: 540px;
        margin-top: 60px;
        background-repeat: no-repeat;
        background-size: cover;
    }
    .desc .txt{
        margin-left: auto;
        font-family: 'Noto Sans JP';
        font-style: normal;
        font-weight: 500;
        font-size: 16px;
        line-height: 38px;
        width: 528px;
        height: 540px;
        background: rgba(255, 255, 255, 0.9);
        display: flex;
        align-items: center;
        justify-content: center;
        padding:0 28px;
        white-space: pre-line;
    }
    h3{
        font-family: "Noto Sans JP",sans-serif;
        margin: 0;
        font-weight: normal;
        font-size: 24px;
        line-height: 35px;
        height: 35px;
        text-align: left;
        color: #000;
        width: fit-content;
        background-color: #FF9B11;
        display: inline-block;
    }
    .hdr-layouts{
        display: flex;
        align-items: center;
        margin-top: 80px;
        margin-bottom: 52px;
    }
    .vr{
        width: 4px;
        height:35px;
        background-color: #FF9B11;
        margin-right: 25px;
        display: inline-block;
    }
    @media screen and (max-width:640px){
        .top-layout{
            flex-direction: column;
            margin-top: 66px;
        }
        h2{
            font-size: 40px;
            margin: 0;
        }
        h2+p{
            margin: 0;
            font-size: 16px;
            margin-top: 16px;
        }
        .desc{
            background-image: url(/img/products/pic_intro_products_mb.png);
            width: 100%;
            height: 408px;
            margin-top: 60px;
            background-repeat: no-repeat;
            background-size: cover;
            display: flex;
            align-items: flex-end;
        }
        .desc .txt{
            margin-left: 0;
            margin-top: auto;
            font-family: 'Noto Sans JP';
            font-style: normal;
            font-weight: 500;
            font-size: 12px;
            line-height: 24px;
            width: 100%;
            height: auto;
            box-sizing: border-box;
            background: rgba(255, 255, 255, 0.9);
            display: flex;
            align-items: center;
            justify-content: center;
            padding:18px 24px;
            white-space: normal;
        }
        h3{
            font-size: 16px;
        }
    }
</style>